var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    id: "i-location",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15 C21 22 16 30 16 30 16 30 11 22 8 15 5 8 10 2 16 2 22 2 27 8 24 15 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDark);
export default __webpack_public_path__ + "static/media/location-dark.3f59a0f009c5f3e5974efe235077ad25.svg";
export { ForwardRef as ReactComponent };